import { render } from "./CommandSetupComponent.vue?vue&type=template&id=7a9c2308&ts=true"
import script from "./CommandSetupComponent.vue?vue&type=script&lang=ts"
export * from "./CommandSetupComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__